import { useTranslation } from 'react-i18next';

import { useNavigateTo } from '@/routes/hooks/use-navigate-to';
import { APP_USER_ROLES } from '@/types';
import { Button } from '@/ui/button/button';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { MinimizedHeader } from '@/ui/typography/across-platform';
import { useUserRole } from '@/user/use-user-role';

import { AskXButton } from '../../../ask-x/ask-x-button';
import { TopbarWrapper } from '../../topbar';
import { SearchProjectsInput } from './search-projects-input';
import { FilterProjectsInput } from './filter-projects-input';
import { NotificationsButton } from '@/features/notifications/notifications-button';

export const ProjectsHeader = () => {
  const navigateTo = useNavigateTo();
  const { t } = useTranslation('projects');
  const role = useUserRole();
  const isAppUserGuest = role?.includes(APP_USER_ROLES.GUEST);

  return (
    <TopbarWrapper
      name="projects-listing"
      justify="space-between"
      alignItems="center"
      gap="16px"
      bgColor="white"
      shadow
    >
      <MinimizedHeader>{t`projects.allProjects`}</MinimizedHeader>

      <Flexbox name="projects-header-actions" gap="23px" alignItems="center">
        <Flexbox gap="10px" name="filter-buttons-container">
          <SearchProjectsInput />
          <FilterProjectsInput />
        </Flexbox>

        <NotificationsButton />

        <AskXButton />

        {!isAppUserGuest ? (
          <Button
            variant="secondary"
            startIcon="Plus"
            onClick={() => navigateTo.createProject()}
          >{t`projects.addProject`}</Button>
        ) : undefined}

        {!isAppUserGuest ? (
          <Button
            variant="secondary"
            startIcon="Plus"
            onClick={() => navigateTo.requestProject()}
          >{t`projects.requestProject`}</Button>
        ) : undefined}
      </Flexbox>
    </TopbarWrapper>
  );
};
